<script lang="ts" setup>
/*
  Design specs for Paragraphs (font-size / line-height) regarding Figma

  Body M
    mobile:  1rem (16px) / 1.375rem (22px)
    tablet:  1rem (16px) / 1.375rem (22px)
    desktop: 1rem (16px) / 1.375rem (22px)

  Body S
    mobile:  0.875rem (14px) / 1.125rem (18px)
    tablet:  0.875rem (14px) / 1.125rem (18px)
    desktop: 0.875rem (14px) / 1.125rem (18px)
*/
import { computed } from "vue";

export interface ParagraphProps {
  size?: "small" | "medium";
  tag?: "p" | "div" | "span"; // keyof HTMLElementTagNameMap;
}

const { size = "medium", tag: customTag } = defineProps<ParagraphProps>();

const paragraphClassName = {
  size: {
    medium: "text-base",
    small: "text-sm",
  },
};

const computedTag = computed(() => customTag || "p");
</script>

<template>
  <component :is="computedTag" :class="[paragraphClassName.size[size]]" data-testid="clr-paragraph">
    <slot />
  </component>
</template>
